<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" dark>
                            <v-card-title class="headline">
                                Misión:
                            </v-card-title>

                            <v-card-text>
                                <p>
                                    * Administrar los recursos (económicos, financieros, materiales, etc) de la empresa
                                    en forma eficiente.
                                </p>
                                <p>
                                    * Colaborar en forma estrecha con los demás departamentos para la satisfacción de
                                    clientes y proveedores, para el logro de los objetivos generales de la empresa.
                                </p>
                                <p>
                                    * Brindar información oportuna, con precisión, confiabilidad y claridad, tanto a
                                    clientes internos como externos.
                                </p>
                                <p>
                                    * Capacitar a las demás áreas en temas que afecten el desenvolvimiento normal y
                                    habitual de la empresa (Impositivos, contables, financieros, comercio exterior,
                                    sistemas, etc).
                                </p>
                                <p>
                                    * Cumplir y hacer cumplir las normativas tanto internas como externas, tales como
                                    requisitos legales, impositivos, etc.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <!-- <v-row dense>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="headline">
                                Objetivos :
                            </v-card-title>
                            <v-card-text>
                                <v-data-table dense :headers="headers" :items="listado" locale="es-ar"
                                    class="elevation-1" :items-per-page="400" hide-default-footer
                                    :item-class="row_classes" :loading="loadtable"
                                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row> -->
            </v-container>
            <v-container>
                <v-row dense>
                    <v-col v-for="(item, i) in listado" :key="i" cols="12" md="6" lg="4">
                        <v-card :color="colorCumplimiento(item.valoractual)">
                            <v-card-title>Objetivo: {{ item.codgral }}</v-card-title>

                            <v-card-text>
                                <div><strong>Descr.:</strong> {{ item.objetivo }}</div>
                                <div><strong>Tipo:</strong> {{ item.tipo }}</div>

                                <div>
                                    <strong>Meta:</strong>
                                    <pre class="meta">{{ item.meta }}</pre>
                                </div>

                                <div><strong>Indicador:</strong> {{ item.indicador }}</div>
                                <div><strong>Responsable:</strong> {{ item.responsable }}</div>
                                <div><strong>Cumplimiento:</strong> {{ item.cumplimiento }}%</div>
                                <div><strong>Valor Indic / Referencia:</strong> {{ item.valoractual }} / {{
                                    item.referencia }}</div>
                                <div><strong>Plan:</strong> {{ item.plan }}</div>
                                <div><strong>Observaciones:</strong> {{ item.observ }}</div>

                                <div>
                                    <strong>Fecha de Actualización:</strong>
                                    {{ item.fecha }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

    </v-app>
</template>
<style>
.meta {
    white-space: pre-wrap;
    /* ← Para permitir varias líneas */
    font-family: inherit;
}
</style>
<script>
// import router from "../src/router/index";
// import axios from "../src/axios-auth.js";
import axios from "../../axios-auth.js";
import moment from "moment";

export default {
    data: () => ({
        usuario: null,
        now: moment(),
        diferencia: "",
        loadtable: false,
        headers: [
            {
                text: "Código",
                align: "center",
                sortable: false,
                value: "codgral",
            },
            { text: "Proceso", value: "proceso", sortable: false },
            { text: "Tipo", value: "tipo", sortable: false },
            { text: "Objetivo", value: "objetivo", align: "center", sortable: false },
            { text: "Meta", value: "meta", align: "center", sortable: false },
            { text: "Responsable", value: "responsable", align: "center", sortable: false },
            { text: "Plazo", value: "plazo", align: "center", sortable: false },
            { text: "Indic.", value: "indicador", align: "center", sortable: false },
            { text: "Valor Anterior", value: "valorant", sortable: false },
            { text: "Valor Actual", value: "valoractual", align: "center", sortable: false },
            { text: "Referencia", value: "referencia", align: "center", sortable: false },
            { text: "Observaciones", value: "observ", sortable: false },
            { text: "Plan", value: "plan", align: "center", sortable: false },
            { text: "Rev.", value: "fecha", align: "center", sortable: false },
        ],
        listado: [],
    }),
    watch: {},
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
        this.cargarListado();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "Administracion";
            //  this.cargaraccidentes();
        }
    },
    methods: {
        colorCumplimiento(item) {
            if (item != null && item != "") {
                if (item == "0") {
                    return "red";
                }
                if (item == "100") {
                    return "green";

                }
                if (item.replace(",", ".") > 0 && item.replace(",", ".") < 100) {
                    return "yellow";
                }
            }
        },

        cargarListado() {
            this.loadtable = true;
            const codgral = "";
            const periodo = "";
            const objetivo = "";
            const meta = "";
            const indicador = "";
            const responsable = "";
            const area = "Administración";
            const tipo = "";
            const asociado = "";

            let self = this;
            axios
                .get("/Indicadores/ListadoObjetivos?", {
                    params: {
                        codgral: codgral,
                        periodo: periodo,
                        objetivo: objetivo,
                        indicador: indicador,
                        responsable: responsable,
                        meta: meta,
                        asociado: asociado,
                        area: area,
                        tipo: tipo,

                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>